import React from 'react';
import { AllClaims } from '../../components/admin/AllClaims';

export const Cancellation = () => {
  // Only show claims with this payment status
  const filterPaymentStatus = "Cancellation";

  return (
    <>
      <AllClaims filterPaymentStatus={filterPaymentStatus} />
    </>
  );
};
